<template>
  <small class="status-stock" :class="this.align">
    <div class="status-stock-content">
      <div v-if="unit === 1"
        class="status-stock-price"
        :class="currentText">
        {{ this.status.current_value | numberDisplay }}
      </div>
      <div class="status-stock-info ml-1" :class="{'lh-11': !currentStatus}">
        <i class="fa fa-regular" :class="currentStatus" v-if="currentStatus"></i>
        <span :class="currentText">({{ currentValue }}{{ this.status.change | percentDisplay('0') }})</span>
        <div class="status-stock-date">
          {{ this.status.period }} 
          <span v-if="unit === 1">{{ $t('common.day_ago') }}</span>
          <span v-if="unit === 4">{{ $t('common.quarter_ago') }}</span>
          <span v-if="unit === 'year'">{{ $t('common.year_ago') }}</span>
        </div>
      </div>
    </div>
  </small>
</template>
<script>
export default {
  name: "ChangeStatus",
  props: ["status", "unit", "isValuation", "align"],
  computed: {
    currentStatus() {
      switch (this.status.type) {
        case 'BETTER_UP':
          return 'fa-arrow-up text-success';
        case 'BETTER_DOWN':
          return 'fa-arrow-down text-success';
        case 'BETTER_LESS':
          return 'fa-arrow-up text-success';
        case 'BETTER_GREATER':
          return 'fa-arrow-up text-success';
        case 'WORSE_UP':
          return 'fa-arrow-up text-danger';
        case 'WORSE_DOWN':
          return 'fa-arrow-down text-danger';
        case 'WORSE_LESS':
          return 'fa-arrow-up text-danger';
        case 'WORSE_GREATER':
          return 'fa-arrow-down text-danger';
        case 'CEIL':
          return 'fa-arrow-up text-winner';
        case 'FLOOR':
          return 'fa-arrow-down text-info';
        default:
          return false;
      }
    },
    currentText() {
      switch (this.status.type) {
        case 'BETTER_UP':
        case 'BETTER_DOWN':
        case 'BETTER_LESS':
        case 'BETTER_GREATER':
          return 'text-success';
        case 'WORSE_UP':
        case 'WORSE_DOWN':
        case 'WORSE_LESS':
        case 'WORSE_GREATER':
          return 'text-danger';
        case 'CEIL':
          return 'text-winner';
        case 'FLOOR':
          return 'text-info';
        default:
          return 'text-warning';
      }
    },
    currentValue() {
      switch (this.status.type) {
        case 'BETTER_DOWN':
        case 'WORSE_DOWN':
          return '-';
        default:
          return '';
      }
    },
  },
};
</script>
<style scoped>
.status-stock {
  position: absolute;
  right: 30px;
  line-height: 5px;
  top: 19px;
  text-align: right;
}
.status-stock.left {
  left: 0;
  text-align: left;
}
.status-stock .status-stock-date {
  font-size: 9px;
}
.status-stock-price {
  font-size: 22px;
  display: inline-block;
  font-weight: 500;
}

.status-stock-info {
  display: inline-block;
}
.status-stock-content {
  min-width: 130px;
}
.lh-11 {
  line-height: 11px;
}
.text-winner {
  color: var(--purple-dark);
}
</style>